function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 24 24"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 9h2V7h4V5h-4V3h-2v6zM7 9v2H3v2h4v2h2V9H7zm6 10v2h-2v-6h2v2h8v2h-8zM3 19v-2h6v2H3zm18-8v2H11v-2h10zm-8-6H3v1.99h10V5z",
  fill: "#666"
})));